/**
 * Sync ATC button price with Kite volume discount widget (gfg* classes).
 * Uses capture-phase listeners because Kite may stop event bubbling.
 */
(function () {
  const KITE_ROOT = '.gfgVolDiscountContainer';
  const GRID_BOX = '.gfgGridBox';
  const SELECTED_PRICE = `${KITE_ROOT} .gfgGridBoxSelected .gfgCostLabel`;
  const ATC_PRICE = '.product-form__submit [data-atc-price], .sticky-atc-bar [data-atc-price]';

  let lastApplied = '';

  function formatPrice(priceText) {
    if (!priceText) return '';
    const match = priceText.trim().match(/(\d+[.,]\d{2})/);
    if (!match) return '';
    return `${match[1].replace('.', ',')} €`;
  }

  function applyPrice(formatted) {
    if (!formatted || formatted === lastApplied) return;
    lastApplied = formatted;

    document.querySelectorAll(ATC_PRICE).forEach((span) => {
      span.textContent = formatted;
    });
  }

  function syncFromSelected() {
    if (!document.querySelector(KITE_ROOT)) return;
    const priceEl = document.querySelector(SELECTED_PRICE);
    applyPrice(formatPrice(priceEl?.textContent || ''));
  }

  function syncFromBox(box) {
    if (!box) return;
    const priceEl = box.querySelector('.gfgCostLabel');
    applyPrice(formatPrice(priceEl?.textContent || ''));
  }

  function scheduleSync(box) {
    if (box) syncFromBox(box);
    [0, 80, 200, 450, 900].forEach((ms) => {
      setTimeout(syncFromSelected, ms);
    });
  }

  function handleGridInteraction(event) {
    const box = event.target.closest?.(GRID_BOX);
    if (!box || !box.closest(KITE_ROOT)) return;
    lastApplied = '';
    scheduleSync(box);
  }

  function bind() {
    if (!document.querySelector(KITE_ROOT)) return;

    document.addEventListener('click', handleGridInteraction, true);
    document.addEventListener('pointerup', handleGridInteraction, true);

    document.addEventListener(
      'change',
      (event) => {
        if (!document.querySelector(KITE_ROOT)) return;
        if (!event.target?.matches?.('input[name="quantity"]')) return;
        lastApplied = '';
        scheduleSync();
      },
      true
    );

    if (window.FoxTheme?.pubsub?.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
        lastApplied = '';
        setTimeout(syncFromSelected, 300);
      });
    }

    setTimeout(syncFromSelected, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  window.addEventListener('load', () => {
    setTimeout(bind, 500);
  });
})();
